export const DEFAULT_HOST_ADDRESS = "http://localhost:1919";
export const RAM_PER_PROFILE = 350;
export const TIME_INTERVAL_IN_SEC = 2;
export const MAX_LOGS = 100;
